import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/auth/authentication.service';

@Component({
    selector: 'app-bra-accept',
    templateUrl: './bra-accept.component.html',
    styleUrls: ['./bra-accept.component.css']
})
export class BraAcceptComponent implements OnInit {

    constructor( private authenticationService: AuthenticationService) { }
    
    user: any;
    PrincipalName = '';
    ngOnInit() {
        this.user = this.authenticationService.user;
        this.PrincipalName = this.user.FirstName + ' ' + this.user.LastName;
    }
}
